import React from "react";
import styles from "./Error404.module.scss";
import { Link } from "react-router-dom";

function Error404() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.errorContainer}>
        <h1 className={styles.heading}>404</h1>
        <p className={styles.subHeading}>Page Not Found</p>
        <p className={styles.description}>
          The page you are looking for doesn't exist or an other error occurred.
        </p>
        <div className={styles.linkContainer}>
          <Link className={styles.link} to="/">
            Go to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Error404;
